import { render } from "./component-default-metrics.vue?vue&type=template&id=1be3139a"
import script from "./component-default-metrics.vue?vue&type=script&setup=true&lang=js"
export * from "./component-default-metrics.vue?vue&type=script&setup=true&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/views/contracts/contract-card/components/component-default-metrics.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "1be3139a"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('1be3139a', __exports__)) {
    api.reload('1be3139a', __exports__)
  }
  
  module.hot.accept("./component-default-metrics.vue?vue&type=template&id=1be3139a", () => {
    api.rerender('1be3139a', render)
  })

}


export default __exports__